<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {
      taskList: [
        { taskId: "Activity_technical", taskName: "问题判定" },
        { taskId: "Activity_1sulfwd", taskName: "措施话术" },
        { taskId: "Activity_0fqlwpd", taskName: "根因分析-审批" },
        { taskId: "Activity_1bumh50", taskName: "永久方案-填写市场话术" },
        { taskId: "Activity_0p8zwt0", taskName: "永久方案-上传巡检记录" },
        { taskId: "Activity_068dwsq", taskName: "永久方案-关闭,同步市场" }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
